import React from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell
} from "@material-ui/core";
import * as Icons from "@material-ui/icons";
import useStyles from "../user/styles";

const states = {
  activo: "green",
  suspendido: "yellow",
  inactivo: "gray",
  borrado: "red",
};

export default function StockTable({ data, currentPage, totalPages, onPreviousPage, onNextPage, onClick, accumulatedItems, totalItems, isSearch }) {
  const classes = useStyles();

  if (data == null || !!(data)) {
  } else {
    var keys = Object.keys(data[0]).map(i => i.toUpperCase());
    keys.shift();
  }

  return (
    <>
      <Table className="mb-0">
        <TableHead>
          <TableRow className={classes.root} >
            <TableCell>NOMBRE</TableCell>
            <TableCell>STOCK</TableCell>
            <TableCell>STOCK MIN.</TableCell>
            {/*{keys.map(key => (
              <TableCell key={key}>{key}</TableCell>
            ))}*/}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(({ id, name, stock, minStock, status }) => (
            <TableRow key={id}
              onClick={onClick(id)}
              className={status == 0 ? classes.tableRowRed : status == 1 ? classes.tableRowYellow : null}
            >
              <TableCell className={classes.tableTextStyle} >{name}</TableCell>
              <TableCell className={classes.tableTextStyle} >{stock}</TableCell>
              <TableCell className={classes.tableTextStyle} >{minStock}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {isSearch != null && isSearch ? (
        <></>
      ) : (
        <>
          <div className={classes.footerTable}>
            <div className={classes.footerTableFirstDiv}>
              <p className={classes.footerText}>TOTAL: {accumulatedItems} DE {totalItems}</p>
            </div>

            <div className={classes.footerTableSecondDiv}>
              <p className={classes.footerText}>PÁGINA: {currentPage} DE {totalPages}</p>
              <div className={currentPage <= 1 ? classes.buttonPageDisableArrowDiv :
                classes.buttonPageEnableArrowDiv}>
                <Icons.ArrowBackIos className={currentPage <= 1 ?
                  classes.buttonPageDisableArrow : classes.buttonPageEnableArrow}
                  onClick={currentPage <= 1 ? null : onPreviousPage}
                />
              </div>
              <div className={classes.spaceBetweenButtons}></div>
              <div className={currentPage == totalPages ? classes.buttonPageDisableArrowDiv :
                classes.buttonPageEnableArrowDiv}>
                <Icons.ArrowForwardIos className={currentPage == totalPages ?
                  classes.buttonPageDisableArrowForward : classes.buttonPageEnableArrowForward}
                  onClick={currentPage == totalPages ? null : onNextPage}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
